<script>
	import Header from './Layout/Header.svelte';
	import Footer from './Layout/Footer.svelte';
	import Router from '../States/Router';
	import Session from '../States/Session';
</script>

{#if $Session.authentication.active}
	<Header/>
{/if}
<svelte:component this="{$Router.component}"/>
{#if $Session.authentication.active}
	<Footer/>
{/if}